module.exports = "<p>\n  request-for-new-pool-modal works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/modals/request-for-new-pool/request-for-new-pool-modal.component.html
// module id = ./src/app/achelos-iot/modals/request-for-new-pool/request-for-new-pool-modal.component.html
// module chunks = main